export function MobileGate() {
  return (
    <main className="mobile-gate">
      <img src="/assets/brand-mark.png" alt="" />
      <span>鞋账罗盘</span>
      <h1>电脑版请使用电脑访问</h1>
      <p>当前网页用于电脑端经营总览、入单、库存和已售管理。手机端请使用微信小程序。</p>
      <div className="mini-program-placeholder" aria-label="小程序二维码尚未开放">小程序二维码<br />备案通过后展示</div>
      <small>此页面不会加载完整 ERP 数据。</small>
    </main>
  );
}
